import { ProfileAdd } from "iconsax-reactjs";
import { useState } from "react";
import CTAs from "./CTAs";
import EmailInputField from "./EmailInputField";

const InviteUser = ({ onClose, onInviteSuccess }) => {
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteName, setInviteName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("authToken");

  const handleInviteUser = async () => {
    if (!inviteEmail.trim()) {
      alert("Please enter an email address");
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/subscription/invite-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          email: inviteEmail,
          name: inviteName,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to invite user");
      }

      alert("Invitation sent successfully!");
      setInviteEmail("");
      setInviteName("");

      if (onInviteSuccess) {
        onInviteSuccess();
      }

      onClose();
    } catch (error) {
      console.error("Error inviting user:", error);
      alert(`Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="relative shadow-[0px_10px_60px_rgba(0,_0,_0,_0.1)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start gap-5 text-left text-base text-neutrals-neutral-900 font-open-sans-ff-meta" style={{ width: 480 }}>
      <div className="self-stretch flex items-start pt-6 px-6 pb-0">
        <div className="flex-1 flex flex-col items-start gap-4">
          <div className="shadow-[0px_-2px_0px_rgba(0,_0,_0,_0.05)_inset,_0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-lg bg-white border-neutrals-neutral-100 border-solid border-[1px] flex items-center p-3">
            <ProfileAdd />
          </div>
          <div className="self-stretch flex flex-col items-start gap-0.5">
            <div className="self-stretch relative font-semibold">
              Invite team members
            </div>
            <div className="self-stretch relative text-sm text-neutrals-neutral-300">
              Invite team members
            </div>
          </div>
        </div>
        <img
          src="assets/cancel.svg"
          className="w-5 h-5 cursor-pointer"
          onClick={onClose}
        />
      </div>
      <div className="self-stretch flex flex-col items-start text-sm">
        <div className="self-stretch flex flex-col items-start py-0 px-6">
          <div className="self-stretch flex flex-col items-start gap-1.5">
            <div className="flex items-center gap-0.5">
              <div className="relative font-semibold">Email</div>
              <div className="relative font-semibold text-red-600">*</div>
            </div>
            <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] overflow-hidden flex items-center p-3 text-[16px] text-slategray">
              <input
                type="email"
                className="flex-1 relative outline-none border-none bg-transparent"
                placeholder="name@yourcompany.com"
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="self-stretch flex items-center pt-8 px-6 pb-6 gap-3">
          <CTAs
            type="Secondarybtn"
            text="Cancel"
            borderColor="border-neutrals-neutral-100"
            onClick={onClose}
            width="w-[170px]"
          />

          <CTAs
            type="Gradientbtn"
            text={isLoading ? "Sending..." : "Send invite"}
            borderColor="border-neutrals-neutral-100"
            onClick={handleInviteUser}
            width="w-[170px]"
          />
        </div>
      </div>
    </div>
  );
};

export default InviteUser;
